import React from 'react';
import { Navbar } from '../Navbar';
import { Footer } from '../Footer';
import { TeacherSignUpLayout } from '../TeacherSignUpLayout';
export const TeacherSignUp = () => {
  return <div className="w-full min-h-screen bg-gradient-to-r from-[#0F1626] via-[#1E3A8A] to-[#2C3E50] text-white font-sans" data-id="element-10258">
      <Navbar data-id="element-10259" />
      <main data-id="element-10260">
        <TeacherSignUpLayout data-id="element-10261" />
      </main>
      <Footer data-id="element-10262" />
    </div>;
};